import { render, staticRenderFns } from "./Try.vue?vue&type=template&id=31830ce8&"
import script from "./Try.vue?vue&type=script&lang=js&"
export * from "./Try.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports